/** Helper function to get a formatted sum from the inputted search */
export const formatSearchSum = (searchSum: string | null) => {
  const dotRegex = /[.,]/g;

  if (!searchSum) {
    return undefined;
  }

  if (dotRegex.test(searchSum)) {
    return parseInt(searchSum.replace(dotRegex, ''));
  } else {
    return parseInt(searchSum) * 100;
  }
};
